(() => {
  if (customElements.get('dm-clube-pontos')) return;

  class ClubePontos extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.status = this.querySelector('[data-club-status]');
      this.installAiHotfix();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-club-open]');
        if (!button || !this.contains(button)) return;
        this.pendingButton?.removeAttribute('aria-busy');
        this.pendingButton = button;
        this.openClub();
      }, { signal: this.controller.signal });
      window.addEventListener('fidelizar-hub:ready', () => {
        if (this.pendingButton) this.openClub();
      }, { signal: this.controller.signal });
    }


    installAiHotfix() {
      if (window.location.pathname.replace(/\/+$/, '') !== '/pages/clube-di-mangiare') return;
      this.aiMedia = window.matchMedia('(max-width: 767px)');
      this.aiQueue = () => {
        if (this.aiFrame) return;
        this.aiFrame = requestAnimationFrame(() => {
          this.aiFrame = null;
          this.syncAiHotfix();
        });
      };
      const update = () => {
        this.removeAiHotfix();
        if (!this.aiMedia.matches) return;
        this.aiStyle = document.createElement('style');
        this.aiStyle.dataset.dmClubeAiHotfix = '';
        this.aiStyle.textContent = `
          @media (max-width: 767px) {
            [data-testid="entrypoint"] {
              right: 8px;
              margin-right: 0;
              bottom: calc(76px + env(safe-area-inset-bottom));
              margin-bottom: 0;
              max-width: 64px;
            }
            [data-testid="entrypoint"][data-dm-clube-obstructed] {
              visibility: hidden;
              pointer-events: none;
            }
            [data-testid="entrypoint"] > [role="button"] {
              width: 64px;
              max-width: 64px;
              overflow: hidden;
              padding: 0;
            }
            [data-testid="entrypoint"] > [role="button"] > div > div + div,
            [data-testid="entrypoint"] > :not([role="button"]) {
              display: none;
            }
          }
        `;
        this.aiDocumentObserver = new MutationObserver(this.aiQueue);
        this.aiDocumentObserver.observe(document.body, { childList: true });
        this.aiResizeObserver = new ResizeObserver(this.aiQueue);
        this.aiResizeObserver.observe(this);
        this.syncAiHotfix();
      };
      this.aiMedia.addEventListener('change', update, { signal: this.controller.signal });
      window.addEventListener('scroll', this.aiQueue, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', this.aiQueue, { passive: true, signal: this.controller.signal });
      update();
    }

    syncAiHotfix() {
      if (!this.aiMedia?.matches || !this.aiStyle) return;
      const root = document.getElementById('ads-agent-host')?.shadowRoot;
      if (root !== this.aiRoot) {
        this.aiShadowObserver?.disconnect();
        this.aiStyle.remove();
        this.aiRoot = root;
        if (root) {
          this.aiShadowObserver = new MutationObserver(this.aiQueue);
          this.aiShadowObserver.observe(root, { childList: true, subtree: true });
        }
      }
      if (root?.querySelector('[data-testid="entrypoint"] > [role="button"]')
          && !this.aiStyle.isConnected) {
        root.appendChild(this.aiStyle);
      }
      const launcher = root?.querySelector('[data-testid="entrypoint"]');
      if (!launcher) return;
      const bounds = launcher.getBoundingClientRect();
      const clearance = 16;
      const obstructed = [...this.querySelectorAll('.dm-points__card, [data-club-open]')]
        .some((element) => {
          const rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0
            && rect.left < bounds.right + clearance && rect.right > bounds.left - clearance
            && rect.top < bounds.bottom + clearance && rect.bottom > bounds.top - clearance;
        });
      launcher.toggleAttribute('data-dm-clube-obstructed', obstructed);
    }

    removeAiHotfix() {
      cancelAnimationFrame(this.aiFrame);
      this.aiFrame = null;
      this.aiDocumentObserver?.disconnect();
      this.aiShadowObserver?.disconnect();
      this.aiResizeObserver?.disconnect();
      this.aiRoot?.querySelector('[data-testid="entrypoint"]')?.removeAttribute('data-dm-clube-obstructed');
      this.aiStyle?.remove();
      this.aiStyle = null;
      this.aiRoot = null;
    }

    openClub() {
      if (typeof window.FidelizarHub?.open === 'function') {
        clearTimeout(this.waitTimer);
        window.FidelizarHub.open();
        this.pendingButton?.removeAttribute('aria-busy');
        this.pendingButton = null;
        this.status.textContent = '';
        return;
      }
      this.pendingButton?.setAttribute('aria-busy', 'true');
      clearTimeout(this.waitTimer);
      this.waitTimer = setTimeout(() => {
        this.pendingButton?.removeAttribute('aria-busy');
        this.pendingButton = null;
        this.status.textContent = this.dataset.unavailable;
        this.status.scrollIntoView({ block: 'nearest' });
      }, 12000);
    }

    disconnectedCallback() {
      this.removeAiHotfix();
      this.controller?.abort();
      clearTimeout(this.waitTimer);
    }
  }

  customElements.define('dm-clube-pontos', ClubePontos);
})();

